import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'fr',
  lng: 'fr',
  debug: true,
  resources: {
    fr: require('./locales/fr.json'),
  },
  interpolation: {
    escapeValue: false,
  },
});
